import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { NavbarComponent } from './navbar/navbar.component';
import { MenuComponent } from './menu/menu.component';
import { ItemMenuComponent } from './menu/item-menu/item-menu.component';
import { LayoutComponent } from './layout.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { RefreshLoginDialogComponent } from './navbar/refresh-login-dialog/refresh-login-dialog.component';

@NgModule({
  declarations: [NavbarComponent, MenuComponent, ItemMenuComponent, LayoutComponent, RefreshLoginDialogComponent],
  imports: [CommonModule, RouterModule, SharedModule, LayoutRoutingModule],
  exports: [MenuComponent, NavbarComponent, LayoutComponent, ItemMenuComponent],
  entryComponents: [RefreshLoginDialogComponent]
})
export class LayoutModule {}
